import {ONBOARDING, LOGIN} from '../actions/types'

const initalState = {bvnVerified: false, submitDetails : false, setPin:false}
const onboardingReducer = (state = initalState, action) => {
  switch (action.type) {
  
    
      

      case ONBOARDING.VERIFY_SUCCESS:
      
      // const verified = action.payload.verified
      const verified = true


      return {...state, bvnVerified: verified }

      case ONBOARDING.VERIFY_FAIL:
        return state

      case ONBOARDING.SUBMIT_DETAILS_SUCCESS:
        const submitDetails = true
        return {...state, submitDetails}
      
        
      case ONBOARDING.SUBMIT_DETAILS_FAIL:
      return state

      case ONBOARDING.SET_PIN_SUCCESS:
      const setPin = true

      return {...state, setPin}

      case ONBOARDING.SUBMIT_DETAILS:
        return {...state, submitDetails: true}

      case ONBOARDING.SET_PIN:
        return {...state, setPin: true}
   
    default:
      return state;
  }
};

export default onboardingReducer;